import { StyleSheet as PDFStyleSheet } from '@react-pdf/renderer'

const styles = PDFStyleSheet.create({
  mainDiv: {
    width: '100%',
    paddingLeft: '5%',
    paddingRight: '5%',
    paddingBottom: 8,
    borderRightWidth: 1,
    borderStyle: 'dashed',
    borderColor: '#dbdbdb'
  },
  content: {
    width: '100%',
    flexDirection: 'column'
  },
  subject: {
    width: '100%',
    marginBottom: 10,
    alignItems: 'flex-end',
    marginTop: 12
  },
  subjectTitle: {
    fontSize: 9,
    color: 'grey',
    marginLeft: 4
  },
  subjectValue: {
    fontSize: 9,
    color: 'black'
  },
  subjectValueRed: {
    fontSize: 9,
    color: 'red'
  },
  phoneNumberContainer: {
    width: '100%',
    marginTop: 6,
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    flexDirection: 'row'
  },
  hotelName: {
    width: '70%',
    flexDirection: 'row-reverse',
    alignItems: 'flex-start'
  },
  hotelNumber: {
    width: '30%',
    flexDirection: 'row-reverse',
    alignItems: 'flex-start'
  }
})
export default styles
